<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售中心</el-breadcrumb-item>
      <el-breadcrumb-item>客户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>

    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form :model="queryForm" class="filter_Form" label-width="100px" ref="queryFormRef">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
                <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    clearable
                >
                    <el-option
                        v-for="item in dict_season"
                        :key="item.dictCode"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select v-model="queryForm.districtId" placeholder="请选择赛区" clearable style="width: 100%">
                <el-option v-for="item in districtList" :key="item.id" :label="item.districtName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="schoolName">
              <el-input v-model="queryForm.schoolName" placeholder="请输入客户名称" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="getDataList('search')">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset">重置</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">待分配客户列表</span>
        </el-col>
      </el-row>
      <el-table header-cell-class-name="tableHeaderStyle" :data="dataList" border stripe v-loading="loading">
        <el-table-column label="序号" type="index" width="60px"></el-table-column>
        <el-table-column label="客户名称" prop="schoolName" min-width="180">
          <template slot-scope="scope">
            {{ scope.row.schoolName }}
            <div style="font-size: 10px; color: #999;">{{ formatAddress(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="赛区" prop="districtName" min-width="120"></el-table-column>
        <el-table-column label="拓展人" prop="expander" min-width="120"></el-table-column>
        <el-table-column label="客户类型" width="180">
          <template slot-scope="scope">{{ schoolTypeFilter(scope.row.schoolType) }}</template>
        </el-table-column>
        <el-table-column label="参赛类型" width="120">
          <template slot-scope="scope">{{ typeflagFilter(scope.row.typeflag) }}</template>
        </el-table-column>
        <el-table-column label="参赛经历" width="120">
          <template slot-scope="scope">{{ attendTypeFilter(scope.row.attendType) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleAssign(scope.row)">分配客户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px"
      ></el-pagination>
    </el-card>
    <el-dialog title="分配客户" :visible.sync="assignVisible" width="420px" :close-on-click-modal="false" append-to-body>
      <el-form :model="assignForm" label-width="90px">
        <el-form-item label="负责人">
          <el-select v-model="assignForm.recipientUserId" placeholder="请选择接收人" style="width: 100%">
            <el-option v-for="item in childUserList" :key="item.id" :label="item.userName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="text-align: center; font-size: 12px; color: #f00;">只分配本赛季数据</div>
      <span slot="footer">
        <el-button @click="assignVisible = false">取 消</el-button>
        <el-button type="primary" :loading="assignLoading" @click="submitAssign">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryDistrictPage, getDictList } from '@/http/api'

export default {
  data () {
    return {
      dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.dict_season = value }),
      loading: false,
      total: 0,
      dataList: [],
      districtList: [],
      schoolTypeList: [],
      queryForm: {
        districtId: '',
        schoolName: '',
        season: this.$chnEngStatusCode.defaultSeason,
        pageNum: 1,
        pageSize: 10
      },
      // 分配弹窗
      assignVisible: false,
      assignLoading: false,
      assignForm: {
        recipientUserId: ''
      },
      childUserList: [],
      currentRow: null
    }
  },
  created () {
    this.getDistrictList()
    this.getDataList()
    this.getSchoolTypeList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 地址拼接
    formatAddress (row) {
      if (!row) return '-'
      const areaStr = [row.province, row.city, row.area].filter((v) => v).join('')
      return areaStr + (row.schoolAddress || '')
    },
    // 获取客户类型字典
    getSchoolTypeList () {
      getDictList({ dictType: 'school_type' }).then((res) => {
        if (res.code === 200) {
          this.schoolTypeList = res.data || []
        }
      }).catch((err) => {
        console.log('getSchoolTypeList err', err)
      })
    },
    // 客户类型：动态字典 dictValue→dictLabel
    schoolTypeFilter (val) {
      const item = this.schoolTypeList.find((s) => String(s.dictValue) === String(val))
      return item ? item.dictLabel : '未知'
    },
    // 参赛类型
    typeflagFilter (val) {
      const map = { 0: '非集体参赛', 1: '集体参赛' }
      return map[val] !== undefined ? map[val] : '未知'
    },
    // 参赛经历
    attendTypeFilter (val) {
      const map = { 0: '有参赛经历', 1: '无参赛经历' }
      return map[val] !== undefined ? map[val] : '未知'
    },
    // 获取赛区下拉列表
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        if (res.code === 200) {
          this.districtList = res.data.list || []
        }
      }).catch((err) => {
        console.log('getDistrictList err', err)
      })
    },
    // 获取待分配客户列表
    getDataList () {
      const params = {}
      Object.keys(this.queryForm).forEach((k) => {
        const v = this.queryForm[k]
        if (v !== '' && v !== null && v !== undefined) {
          params[k] = v
        }
      })
      this.loading = true
      this.$http.get('schoolTrack/unassignedList', { params }).then((res) => {
        if (res.code === 200) {
          this.dataList = res.data.list || []
          this.total = res.data.total || 0
        }
        this.loading = false
      }).catch((err) => {
        console.log('getDataList err', err)
        this.loading = false
        this.$message.error('获取列表失败')
      })
    },
    // 重置
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 分配
    handleAssign (row) {
      this.currentRow = row
      this.assignVisible = true
      this.assignForm.recipientUserId = ''
      this.$http.get('erp/getChildUser').then((res) => {
        if (res.code === 200) {
          this.childUserList = res.data || []
        }
      })
    },
    submitAssign () {
      if (!this.assignForm.recipientUserId) {
        this.$message.warning('请选择接收人')
        return
      }
      this.$http.post('schoolTrack/allocation', {
        recipientUserId: this.assignForm.recipientUserId,
        schoolId: this.currentRow.schoolId || this.currentRow.id
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('分配成功')
          this.assignVisible = false
          this.getDataList()
        }
      }).catch((err) => {
        console.log('submitAssign err', err)
        this.$message.error('分配失败')
      })
    },
    // 搜索/筛选时重置页码
    searchResetPage () {
      this.queryForm.pageNum = 1
    }
  }
}
</script>
<style lang="less" scoped>
</style>
